import store from '../store'
import {
    SET_SYSTEM_REDIRECT_BACK_LINK,
    SET_SYSTEM_REDIRECT_CLEAR,
    SET_SYSTEM_REDIRECT_FORWARD_LINK,
    SET_SYSTEM_REDIRECT_LINKS,
} from '../reducers/system-redirect'

/**
 * Set system redirect backlink
 * @param {string|null} link
 */
export const setSystemRedirectBackLink = link => {
    store.dispatch({
        type: SET_SYSTEM_REDIRECT_BACK_LINK,
        backLink: link,
    })
}

/**
 * Set system redirect backlink
 * @param {string|null} link
 */
export const setSystemRedirectForwardLink = link => {
    store.dispatch({
        type: SET_SYSTEM_REDIRECT_FORWARD_LINK,
        forwardLink: link,
    })
}

/**
 * Set system redirect backlink
 */
export const setSystemRedirectClear = () => {
    store.dispatch({
        type: SET_SYSTEM_REDIRECT_CLEAR,
    })
}

/**
 * Set system redirect backlink
 * @param {string|null} backLink
 * @param {string|null} forwardLink
 * @param {boolean} isLoginRedirect
 */
export const setSystemRedirectLinks = (backLink, forwardLink, isLoginRedirect) => {
    store.dispatch({
        type: SET_SYSTEM_REDIRECT_LINKS,
        backLink: backLink,
        forwardLink: forwardLink,
        isLoginRedirect: isLoginRedirect,
    })
}
